import {
  Swiper,
  Navigation,
  Thumbs,
} from 'swiper';

import productColors from './productColors';
import setProductGallery from './productGallery';

Swiper.use([
  Navigation,
  Thumbs,
]);

const singleproductInit = (): void => {
  setTimeout(() => {
    // Variables
    const options = document.querySelectorAll('.yith_wccl_is_custom') as NodeListOf<HTMLElement>;
    const selectOptions = document.querySelectorAll('.select_option') as NodeListOf<HTMLElement>;
    const prices = document.querySelectorAll('.snep-product__price') as NodeListOf<HTMLElement>;
    let currentImages = [];
    let imagesInterval;
    let first = false;

    // Set swiper sliders
    const slider = document.querySelector('.snep-swiper-gallery') as HTMLElement;
    const sliderParent = slider.closest('.snep-image-gallery') as HTMLElement;
    const thumbs = sliderParent.querySelector('.snep-swiper-thumbs') as HTMLElement;

    const thumbSwiper = new Swiper(thumbs, {
      loop: false,
      spaceBetween: 16,
      slidesPerView: 4,
      watchSlidesProgress: true,
      freeMode: true,

      breakpoints: {
        992: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
    });

    const imageSwiper = new Swiper(slider, {
      loop: true,
      speed: 500,
      keyboard: true,
      slidesPerView: 1,
      spaceBetween: 0,
      slideActiveClass: 'slider__slide--active',

      navigation: {
        nextEl: '.snep-swiper-gallery__next',
        prevEl: '.snep-swiper-gallery__prev',
      },
      thumbs: {
        swiper: thumbSwiper,
      },
    });

    imageSwiper.activeIndex = 1;

    // Functions
    const addLabel = (value: string, element: HTMLElement): void => {
      if (!element || !value) return;
      const el = element as HTMLElement;
      el.innerHTML = value;
    };

    const getNewPrice = () => {
      const newPrice = document.querySelector('.woocommerce-variation-price .price') as HTMLElement;
      return newPrice?.innerHTML;
    };

    const setPrice = (newPrice) => {
      [...prices].forEach((price) => {
        const ele = price;
        ele.innerHTML = '';

        const priceElement = document.createElement('span');
        priceElement.innerHTML = newPrice;
        price.insertAdjacentElement('afterbegin', priceElement);
      });
    };

    const setInactiveColors = (colors, timeout: number) => {
      const innerColors = colors.querySelectorAll('.select_option_colorpicker') as NodeListOf<HTMLElement>;
      const parent = colors.closest('.variations') as HTMLElement;
      const snepColors = parent.querySelectorAll('.color-card') as NodeListOf<HTMLElement>;

      [...snepColors].forEach((snepColor) => {
        snepColor.classList.remove('color-card--hidden');
      });

      [...innerColors].forEach((color) => {
        setTimeout(() => {
          if (color.classList.contains('inactive')) {
            const dataColor = color.dataset.value;

            [...snepColors].forEach((snepColor) => {
              if (snepColor.dataset.color === dataColor) {
                snepColor.classList.remove('color-card--active');
                snepColor.classList.add('color-card--hidden');
              }
            });
          }

          if (color.classList.contains('selected')) {
            const dataColor = color.dataset.value;

            [...snepColors].forEach((snepColor) => {
              if (snepColor.dataset.color === dataColor) {
                snepColor.classList.remove('color-card--hidden');
                snepColor.classList.add('color-card--active');
              }
            });
          } else {
            const dataColor = color.dataset.value;

            [...snepColors].forEach((snepColor) => {
              if (snepColor.dataset.color === dataColor) {
                snepColor.classList.remove('color-card--active');
              }
            });
          }
        }, timeout);
      });
    };

    const updateOldImages = (newImages) => {
      const newImageArray = [];
      [...newImages].forEach((image) => {
        newImageArray.push(image.src);
      });

      // Update currentImages;
      currentImages = newImageArray;
    };

    const getProductImages = (oldImages) => {
      let update = true;
      let intervalNumber = 0;

      // Show the loader
      const imageLoader = document.querySelector('.snep-image-loader') as HTMLElement;

      imagesInterval = setInterval(() => {
        const wcProductImage = document.querySelectorAll('.woocommerce-product-gallery__image img') as NodeListOf<HTMLImageElement>;
        intervalNumber += 1;

        if (intervalNumber <= 10 && update) {
          [...wcProductImage].forEach((img) => {
            if (!oldImages.includes(img.src) && update) {
              imageLoader.classList.add('snep-image-loader--active');
              updateOldImages(wcProductImage);
              setProductGallery(wcProductImage, imageSwiper, thumbSwiper, imageLoader);
              update = false;
            }
          });
        } else {
          clearInterval(imagesInterval);
          imageLoader.classList.remove('snep-image-loader--active');
        }
      }, 1000);
    };

    const labelLoop = (values, timeout: number) => {
      const allOptions = values;

      // clearImagesInterval
      clearInterval(imagesInterval);

      [...allOptions].forEach((option) => {
        const select = option.querySelector('.yith_wccl_custom') as HTMLSelectElement;
        const parent = option.closest('tr') as HTMLElement;
        const label = parent.querySelector('.product-attr-option') as HTMLElement;
        let value = select[select.selectedIndex].innerText;

        if (select.value === '') {
          value = '-';
        }

        if (select.name === 'attribute_pa_kleur' && !first) {
          first = true;

          const snepColorImages = document.querySelector('.snep-color-images') as HTMLElement;
          const newElement = document.createElement('div');
          if (snepColorImages) {
            newElement.innerHTML = snepColorImages.innerHTML;
          }
          newElement.className = 'snep-color-images';

          parent.insertAdjacentElement('beforeend', newElement);

          // Init the new elements
          productColors();

          const yithColors = parent.querySelector('.select_box_colorpicker') as HTMLElement;
          yithColors.style.display = 'none';
          setInactiveColors(yithColors, 1000);
        } else if (select.name === 'attribute_pa_kleur') {
          const yithColors = parent.querySelector('.select_box_colorpicker') as HTMLElement;
          setInactiveColors(yithColors, 1);
        }

        // Send the value and the label to addLabel function
        addLabel(value, label);
      });

      // Get the ProductImages
      getProductImages(currentImages);

      // Set timeout to show a new price
      setTimeout(() => {
        if (getNewPrice() !== '' && getNewPrice() !== undefined) {
          setPrice(getNewPrice());
        }
      }, timeout);
    };

    // Load
    if (options) {
      labelLoop(options, 1000);
    }

    // Loop through all the selectOptions
    if (options) {
      [...selectOptions].forEach((option) => {
        option.addEventListener('click', () => {
          labelLoop(options, 1);
        });
      });
    }
  }, 100);

  // insert sizeChartToggle in size block - single product
  const sizeChartToggle: HTMLElement = document.querySelector('.size-chart__toggler');
  const receivingElement: HTMLElement = document.querySelector('.select_box_label.select_box.attribute_pa_maat');

  if (sizeChartToggle) {
    if (receivingElement) {
      receivingElement.insertAdjacentElement('afterend', sizeChartToggle);
    } else if (!receivingElement) {
      sizeChartToggle.style.display = 'none';
    }
  }
};

export default singleproductInit;
